"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors = {};
exports.default = colors;
//# sourceMappingURL=colors.js.map